import { LocaleMessages } from 'vue-i18n'
import Translate from '../../../modules/util/Translate'
import recommend from '../../../components/recommend/language'

const language: LocaleMessages = {
  en: {
    RecommendShowModal: {
      button: 'Recommended Applications'
    }
  },
  es: {
    RecommendShowModal: {
      button: 'Aplicaciones recomendadas'
    }
  },
  'pt-br': {
    RecommendShowModal: {
      button: 'Aplicações recomendadas'
    }
  }
}

export default Translate([language, recommend])
